import { useCallback } from 'react';
import { Box, Text } from '@frameio/vapor';
import { useQuickSearchModal } from '../../../../../shared/contexts';
import { useTrackRecentlyOpenedSelected } from '../../../../../shared/contexts/SearchAnalyticsContext';
import { useQuickSearchModalData } from '../../../../contexts';
import { ProjectCard } from './components';
import TEXT from './generated/TEXT/RecentlyViewed';

TEXT.DEFINE({
  /** Section title for recently viewed projects */
  title: 'Recents',
});

export const RecentlyViewed = () => {
  const { closeModal } = useQuickSearchModal();
  const { recentProjects, hasRecentProjects } = useQuickSearchModalData();
  const trackRecentlyOpenedSelected = useTrackRecentlyOpenedSelected();

  const handleOnClick = useCallback(
    (name: string, href: string) => {
      trackRecentlyOpenedSelected('Project', name);
      closeModal({ navigatingTo: href });
    },
    [trackRecentlyOpenedSelected, closeModal]
  );

  if (!hasRecentProjects) return null;

  return (
    <Box display="flex" flexDirection="column">
      <Box padding={8}>
        <Text color="tertiary" fontWeight="medium" variant="secondary">
          {TEXT.title}
        </Text>
      </Box>
      <div>
        {recentProjects.map((project) => (
          <ProjectCard
            key={project?.id}
            id={project?.id ?? ''}
            imageUrl={project?.imageUrl ?? ''}
            name={project?.name ?? ''}
            onClick={handleOnClick}
            storage={project?.storage ?? 0}
            workspaceName={project?.workspace?.name ?? ''}
          />
        ))}
      </div>
    </Box>
  );
};
